import { ProductIndexCard } from './productIndexCard/ProductIndexCard';
import * as style from './style.css';
import { IBreadcrumb } from '../../framework/framework/shared/models/IBreadcrumb';
import IndexComponent, { IIndexProps, IIndexState } from '../../framework/framework/index/IndexComponent';
import Breadcrumbs from '../../framework/framework/components/Breadcrumbs';
import Emitter from '../../services/eventEmmiter/EventEmmiter';
import { EventTypes } from '../../services/eventEmmiter/EventTypes';
import { Helmet } from 'react-helmet';
import HotItems from '../home/hotItems/HotItems';
import CatalogSortOrder from './catalogSortOrder/CatalogSortOrder';
import { IColumnOrder, IOrderModel, IOrderOption } from '../../framework/framework/index/order/IOrderModel';
import { ProductService } from '../../services/productService/ProductService';

import React = require('react');

export interface IProps extends IIndexProps {
    slug: string;
    searchText: string;
    order: string;
    promoItems: boolean;
}

export interface IState extends IIndexState {
       breadcrumbs: IBreadcrumb[];
    title: string;
    description: string;
}

export default class CatalogIndex extends IndexComponent<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            results: [],
            columns: [],
            filterVM: { model: { taxonomySlug: props.slug, searchText: props.searchText, promoItems: props.promoItems }, value: {}, properties: [] },
            timerValue: null,
            title: '',
            description: '',
            paging: null,
            indexBatchButtonsCollection: [],
            orderModel: this.getSorting(props),
            editUrl: '',
            deleteUrl: '',
            createUrl: '',
            selectedIds: [],

            breadcrumbs: [],
            indexButtons: [],
            rowButtons: []
        };
    }

    getSorting(props: IProps): IOrderModel {
        if (props.order === 'ascending') { return { order: [{ columnName: 'Name', order: IOrderOption.Ascending }] }; }
        if (props.order === 'descending') { return { order: [{ columnName: 'Name', order: IOrderOption.Descending }] }; }

        return null;
    }

    protected updateResponseData(data: any, messages: string[]) {
        this.setState({ breadcrumbs: data.breadcrumbs, title: data.title, description: data.description });
        Emitter.emit(EventTypes.TaxonomyTree, data.taxonomyTree);
        if (messages.length > 0) {
            messages.forEach(m => {
                Emitter.emit(EventTypes.Message, m);
            });
        }
    }

    render() {
        debugger;
        return (<div className={style.catalogForm}>
            <Helmet>
                <title>{this.state.title}</title>
                <meta name="description" content={this.state.description} />
            </Helmet>
            <div className={style.header}>
                <Breadcrumbs breadcrumbs={this.state.breadcrumbs} />
            </div>
            <div className={style.indexWrapper}>
                <div className={style.resultPage}>
                    {
                        <CatalogSortOrder orderModel={this.state.orderModel} onOrderChange={(order: IColumnOrder[]) => this.onSortChange(order)} />
                    }
                    <div className={style.results}>
                        {this.state.results && this.state.results.map((x) =>
                            <ProductIndexCard key={x.id}
                                item={x}
                                buyClick={(id, name) => this.handleItemBuy(id, name)}
                            />
                        )
                        }
                    </div>
                </div>
            </div>
            <HotItems
                appCtx={this.props.appCtx}
                url={'Catalog/PromoItems'}
                title={'Promocja'} />
            <HotItems
                appCtx={this.props.appCtx}
                url={'Catalog/BestItems'}
                title={'Polecane'} />
            <HotItems
                appCtx={this.props.appCtx}
                url={'Catalog/ReviewedItems'}
                title={'Ostatnio oglądane'} />
        </div>);
    }

    handleItemBuy(id: number, name: string): void {
        const productService = ProductService.Instance();
        productService.addToBasket(id, name, 1);
    }
}
